import styled from 'styled-components';
import { IStyleProps } from '../interfaces';

export const CustomLabel = styled.label<IStyleProps>`
  font-style: normal;
  line-height: ${props => props.lineHeight};
  text-align: ${props => props.textAlign};
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  font-size: ${props => props.fontSize};
  font-weight: ${props => props.fontWeight};
  color: ${props => props.color};
  word-break: ${props => props.wordBreak};
  &.font-15-ss-13 {
    font-size: 15px;
  }
  @media (max-width: 768px) {
    &.font-15-ss-13 {
      font-size: 13px;
    }
  }
`;

CustomLabel.defaultProps = {
  lineHeight: '22px',
  textAlign: 'left',
  margin: '0px',
  padding: '0px',
  fontSize: '16px',
  fontWeight: 400,
  color: '#555',
  wordBreak: 'break-word',
};
